import type { RouteRecordRaw } from 'vue-router'
import { PERMISSIONS } from '@/core/permissions/constants'

export const assetRoutes: RouteRecordRaw[] = [
  {
    path: '/assets',
    name: 'assets-library',
    component: () => import('@/modules/assets/views/AssetsLibraryView.vue'),
    meta: {
      permission: PERMISSIONS.MEDIA.VIEW,
      projectScoped: true,
    },
  },
]
